import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\details\\CollegeDetails.jsx");
